import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, App as AntdApp, Button, Input, Typography } from 'antd';
import { LeftOutlined, MessageOutlined } from '@ant-design/icons';
import { submitFeedback } from '../api/feedback.js';

export default function Feedback() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { message } = AntdApp.useApp();
	const [content, setContent] = useState('');
	const [submitting, setSubmitting] = useState(false);

	const onSubmit = async () => {
		const text = content.trim();
		if (!text) {
			message.warning(t('mtab.profile.feedback_required'));
			return;
		}
		setSubmitting(true);
		const result = await submitFeedback(text);
		setSubmitting(false);
		if (result.ok) {
			message.success(result.msg || t('mtab.profile.feedback_success'));
			setContent('');
		} else {
			message.error(result.msg || t('common.failed', { defaultValue: '提交失败' }));
		}
	};

	return (
		<div style={{ background: '#f5f5f5', minHeight: '100vh' }}>
		<div style={{ maxWidth: 720, margin: '0 auto' }}>
			<div style={{
				display: 'flex', alignItems: 'center',
				padding: '12px 12px', background: '#fff',
				borderBottom: '1px solid #f0f0f0',
			}}>
				<Button type="text" shape="circle" icon={<LeftOutlined />} onClick={() => navigate(-1)} />
				<Typography.Text strong style={{ flex: 1, textAlign: 'center', fontSize: 17 }}>
					{t('mtab.profile.feedback')}
				</Typography.Text>
				<div style={{ width: 32 }} />
			</div>

			<div style={{ padding: 16 }}>
				<Alert
					type="info"
					showIcon
					message={t('mtab.profile.feedback_api_verified', {
						defaultValue: '反馈提交接口已按海外 APK 静态证据接入；提交失败会显示后端真实错误。',
					})}
					style={{ marginBottom: 12 }}
				/>
				<div style={{
					background: '#fff',
					borderRadius: 12,
					padding: 16,
					marginBottom: 16,
				}}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
						<MessageOutlined style={{ color: '#FF6347' }} />
						<Typography.Text strong>{t('mtab.profile.feedback')}</Typography.Text>
					</div>
					<Input.TextArea
						value={content}
						onChange={(e) => setContent(e.target.value)}
						placeholder={t('mtab.profile.feedback_placeholder')}
						maxLength={500}
						showCount
						rows={6}
					/>
				</div>
				<Button
					type="primary"
					block
					loading={submitting}
					onClick={() => void onSubmit()}
					style={{ height: 44, borderRadius: 8 }}
				>
					{t('mtab.profile.feedback_submit')}
				</Button>
			</div>
		</div>
		</div>
	);
}
